export default __webpack_public_path__ + "static/media/pepper.503f6fb1.svg";